import React, {Fragment} from "react";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";
import {withRouter} from "react-router-dom";

import AssignmentIcon from "@mui/icons-material/Assignment";
import IconButton from "@mui/material/IconButton";

import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";
import {
  setLookDemoPointsClicked,
  setLookIntroStep, setLookOpened,
  setLookOverlayOpened,
  setLookPageOpened
} from "../../../../actions/lookFunctions";
import {ROUTES} from "../../../../routes";
import {LOCAL_STORAGE_KEYS, LOOK_INTRO_STEPS_MOBILE} from "../../core/constants";
import {setLocalStorageItem} from "../lookFunctions";
import LookIntroFooterAnchor from "../lookIntro/lookIntroFooterAnchor";

const LookMobileFooterButton = (props) => {

  const {intl, history, visualizersLoadedLength, lookOpened, setLookDemoPointsClicked, setLookPageOpened,
    lookPageOpened, setLookOverlayOpened, introStep, setLookIntroStep, setLookOpened, hideYourListButton} = props;

  if (hideYourListButton) {
    return null
  }

  const lookMobileFooterButtonClick = () => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookFooterList);

    if (!visualizersLoadedLength) {
      return false
    }

    if (introStep === LOOK_INTRO_STEPS_MOBILE.review) {
      setLookOverlayOpened("");
      setLocalStorageItem(LOCAL_STORAGE_KEYS.introVisited, true);
      setLookIntroStep(LOOK_INTRO_STEPS_MOBILE.welcome); // to prevent button active
    }

    if (!lookOpened) {
      setLookDemoPointsClicked(true);
    } else {
      setLookOpened(false);
    }

    setLookPageOpened(lookPageOpened === ROUTES.list ? "" : ROUTES.list);
    history.push(lookPageOpened === ROUTES.list ? ROUTES.home : ROUTES.list);
  }

  return (
    <Fragment>
      <IconButton aria-label={intl.formatMessage({id:"tooltip.editLook"})}
                  className={"look-icon lm-footer__mobile-button"
                    + (lookPageOpened === ROUTES.list && visualizersLoadedLength ? " look-icon--active" : " look-icon--white2")
                    + (introStep === LOOK_INTRO_STEPS_MOBILE.review ? " lm-footer__mobile-button--on-top" : "")}
                  onClick={lookMobileFooterButtonClick}>
        <AssignmentIcon />
      </IconButton>
      <LookIntroFooterAnchor currentStep={LOOK_INTRO_STEPS_MOBILE.review}/>
    </Fragment>
  )
};

const mapStateToProps = (store) => {
  const {visualizersLoaded} = store.serverState;
  const {lookOpened, introStep, lookPageOpened} = store.lookState;
  const {hideYourListButton} = store.fabricatorState.settings;

  return {
    lookOpened,
    lookPageOpened,
    introStep,
    visualizersLoadedLength: visualizersLoaded.length,
    hideYourListButton,
  };
};

const mapDispatchToProps = {
  setLookDemoPointsClicked,
  setLookPageOpened,
  setLookIntroStep,
  setLookOverlayOpened,
  setLookOpened,
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(LookMobileFooterButton)
  )
)
